import Documents from '../../../components/Common/Documents/DocumentsCont'
import ControlledDocForm from '../../../components/HSEQ/ControlledDocuments/ControlledDocForm'
import React from 'react'
import { Modal, Row, Tabs } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'

const { TabPane } = Tabs

function ControlledDocModal(props) {
  const {
    visible,
    submitting,
    submit,
    update,
    modalType,
    onCancel,
    removing,
    remove,
    controlledDoc,
    formRef,
    isNew,
  } = props

  return (
    <Modal
      visible={visible}
      title={'Controlled Document'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={true}
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Controlled Document'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'85%'}>
      <Tabs defaultActiveKey="form">
        <TabPane tab="Form" key="form">
          <Row>
            <ControlledDocForm ref={formRef} {...props} />
          </Row>
        </TabPane>
        <TabPane disabled={modalType !== 'edit'} tab="Files" key="files">
          <Documents key={controlledDoc._rev} editable={true} footer={false} category={false} owner={controlledDoc} />
        </TabPane>
      </Tabs>
    </Modal>
  )
}

ControlledDocModal.propTypes = {}
ControlledDocModal.defaultProps = {}

export default ControlledDocModal
